// Set axios defaults to use for each request
import axios from 'axios';
axios.defaults.baseURL = localized_data.ajaxurl;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
//Libraries
import './libs/gsap.min';
import './libs/gaspScrollTrigger.min';
// Animations
import './animations/fadeInOnScroll';
import './animations/smoothScroll';
import './animations/pageLoader';
//Functions
// import './functions/headerScroll';
import './functions/savingsCalculator';
import './functions/swiper';
import './functions/accordion';
import './functions/navOverlay';
import './functions/mainMenu';

// Import main scss file here. This will compile to a css file in the dist folder
import '../scss/style.scss';